import { createI18n } from 'vue-i18n';
import sk from '@src/locale/sk';

const locale = document.documentElement.lang || 'sk';

export const i18n = createI18n({
    globalInjection: true,
    legacy: false,
    locale: locale,
    messages: {
        sk,
    },
});
